<template>
	<div class="table-map">
		<div class="table-title">
			微站数据表
			<el-button 
				@click="closeTable"
				type="primary" 
				icon="el-icon-close" 
				circle 
				size="mini" 
				style="position: absolute;right: 5px;top: 5px">
			</el-button>
		</div>
		<div class="table-content">
			<div class="table-export">
				<el-input
					size="small"
			    placeholder="请输入名称、设备号搜索"
			    prefix-icon="el-icon-search"
			    v-model="searchVal"
			    width="200px"
			    style="width: 200px">
			  </el-input>
				<el-button @click="exportTable" type="primary" size="mini" style="float: right;">导出</el-button>	
        
			</div>
			<el-table
		    :data="tableDataPaged"
        height="560"
		    border
		    size="small"
        style="width: 500px"
		    >

        <el-table-column
        label="#"
        type="index"
        :index="indexMethod">
      </el-table-column>
        

		    <el-table-column
          width="100"
		      label="微站名称"
		      >
		      <template slot-scope="scope">
		        <a style="cursor: pointer;" @click="toPoint(scope.row)">{{ scope.row.station_name }}</a>
		      </template>
		    </el-table-column>
			
		    <el-table-column
          width="100"
		      label="设备号"
		      prop="sn">
		    </el-table-column>

        <el-table-column
		    	width="100"
		      label="PM₁₀ K值"
          sortable
		      prop="pm10_k">
		    </el-table-column>

        <el-table-column
		    	width="100"
		      label="PM₂.₅K值"
          sortable
		      prop="pm25_k">
		    </el-table-column>

        <el-table-column
		    	width="100"
          sortable
		      label="PM₁₀偏差"
		      prop="pm10_index_deviation_rate">
		    </el-table-column>

        <el-table-column
		    	width="120"
          sortable
		      label="PM2.5偏差"
		      prop="pm25_index_deviation_rate">
		    </el-table-column>

        

        <el-table-column
		    	width="120"
		      label="PM₁₀低值"
          sortable
		      prop="pm10_exceed_lower_limit_count">
		    </el-table-column>

        <el-table-column
		    	width="120"
		      label="PM2.5低值"
          sortable
		      prop="pm25_exceed_lower_limit_count">
		    </el-table-column>

        <el-table-column
		    	width="120"
		      label="PM₁₀高值"
          sortable
		      prop="pm10_exceed_upper_limit_count">
		    </el-table-column>

        <el-table-column
		    	width="120"
		      label="PM2.5高值"
          sortable
		      prop="pm10_exceed_upper_limit_count">
		    </el-table-column>

        <el-table-column
		    	width="120"
		      label="周围站点数"
          sortable
		      prop="around_station_count">
		    </el-table-column>
        <el-table-column
		    	width="120"
		      label="PM₁₀有效数"
          sortable
		      prop="valid_pm10_count">
		    </el-table-column>

        <el-table-column
		    	width="120"
		      label="PM2.5有效数"
          sortable
		      prop="valid_pm25_count">
		    </el-table-column>

        <el-table-column
		    	width="80"
		      label="区县"
		      prop="quxian">
		    </el-table-column>

		    <el-table-column
		    	width="100"
		      label="街镇"
		      prop="jiezhen">
		    </el-table-column>
        <el-table-column
		    	width="100"
		      label="运营商"
		      prop="vendor_name">
		    </el-table-column>

			</el-table>
        <!-- <el-pagination
          layout="prev, pager, next"
          :total="tableFiltered.length"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          >
        </el-pagination> -->

		</div>
		
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FileSaver from '@/utils/plugins/FileSaver'
import { name_options } from '@/options/option'
import { validFilter } from '@/utils/util'
export default {
	data () {
		return {
			searchVal: '',
			search:'',
      name_options,
      pageSize: 10000,
      currentPage: 1
		}
	},
	computed: {
		...mapState(['cur_time', 'stations']),
		tableFiltered() {
			var d =  this.tableData.filter(
				data => !this.searchVal || 
				data.station_name.toLowerCase().includes(this.searchVal.toLowerCase()) || 
				data.sn.toLowerCase().includes(this.searchVal.toLowerCase())
      )
      return d
    },
    tableDataPaged() {
      return this.tableFiltered.slice((this.currentPage -1) * this.pageSize, this.currentPage * this.pageSize)
    }
	},
	props:{
		tableData: Array,
		data_type: String
	},
	methods: {
		validFilter,
		closeTable() {
			this.$emit("closeTable")
		},
		toPoint(info) {
      console.log(info)
      for (var i of this.stations) {
        if (i.DevSN === info.sn) {
          this.$emit("toPoint", i)
          break
        }
      }
			
    },
    indexMethod(index) {
      return index + (this.currentPage -1) * this.pageSize + 1;
    },
		exportTable() {
			// var content = [`序号, 道路名称, 路段中心位置, 街镇, 区县, PM₁₀, PM₂.₅, 数据量, 百度街镇, 百度区县\n`];
			var content = [`序号, 微站名称, 设备号, PM₁₀偏差,PM2.5偏差, PM₁₀ K值,PM₂.₅K值,PM₁₀低值,PM2.5低值,PM₁₀高值,PM2.5高值,周围站点数,PM₁₀有效数,PM2.5有效数,区县,街镇,运营商\n`];
    	for (let i in this.tableFiltered){
    		let info = this.tableFiltered[i]
        let text = `${parseInt(i)+1}, ${info.station_name}, ${info.sn}\t, ${info.pm10_index_deviation_rate}, ${info.pm25_index_deviation_rate},${info.pm10_k}, ${info.pm25_k}, ${info.pm10_exceed_lower_limit_count}, ${info.pm25_exceed_lower_limit_count}, ${info.pm10_exceed_upper_limit_count}, ${info.pm25_exceed_upper_limit_count},${info.around_station_count}, ${info.valid_pm10_count}, ${info.valid_pm25_count}, ${info.quxian}, ${info.jiezhen}, ${info.vendor_name}\n`
    		content.push([text])
    	}
    	var file_name = '微站偏差数据'
      var blob = new Blob(content, { type: "text/plain;charset=utf-8" });
      FileSaver.saveAs(blob, file_name + ".csv");
		}
	}
}
</script>

<style>

.table-map {
	position: absolute;
	top: 0;
	z-index: 100;
	width: auto;
	border: 1px solid black;
	background: white;
	margin-left: 470px;
	margin-top: 0px;
	border-radius: 10px;
}

.table-title{
	color: white;
	font-size: 18px;
	height: 40px;
	line-height: 40px;
	background: #1891ff;
	padding-left: 20px;
	border-radius: 10px 10px 0 0 
}

.table-content{
	padding:10px 10px;
}

.table-export {
	margin-bottom: 5px;
	position: relative;
	height: 30px;
	line-height: 30px
}
</style>


// WEBPACK FOOTER //
// src/components/common/StationDiffTable.vue